import type { AxisScale } from '@visx/axis';

import type { NearestDatumArgs, NearestDatumReturnType } from '../types/event';

import { findNearestDatumSingleDimension } from './findNearestDatumSingleDimension';

export function findNearestDatumY<XScale extends AxisScale, YScale extends AxisScale, Datum extends object>({
  yScale: scale,
  yAccessor: accessor,
  xScale,
  xAccessor,
  point,
  data,
}: NearestDatumArgs<XScale, YScale, Datum>): NearestDatumReturnType<Datum> {
  if (!point) {
    return null;
  }

  const nearestDatum = findNearestDatumSingleDimension<YScale, Datum>({
    scale,
    accessor,
    scaledValue: point.y,
    data,
  });

  return nearestDatum
    ? {
        datum: nearestDatum.datum,
        index: nearestDatum.index,
        distanceY: nearestDatum.distance,
        distanceX: Math.abs(Number(xScale(xAccessor(nearestDatum.datum))) - point.x),
      }
    : null;
}
